import React, { useContext } from 'react';

import {
  SearchInput,
  SearchInputProps,
  DefaultSearchInput,
} from '../SearchInput';

import { SelectOption, SelectProps } from '../types';
import { SelectContext } from './context/SelectProvider';

export type SelectSearchInputProps = Pick<
  SearchInputProps,
  'searchAutofocus' | 'placeholder' | 'className'
> &
  Pick<SelectProps<SelectOption>, 'enableNewSearchInput'>;

const SelectSearchInput = ({
  enableNewSearchInput,
  ...rest
}: SelectSearchInputProps) => {
  const { shouldShowSearchInput, searchInputValue, setSearchInputValue } =
    useContext(SelectContext);

  const SelectedSearchInput = enableNewSearchInput
    ? SearchInput
    : DefaultSearchInput;

  return shouldShowSearchInput ? (
    <SelectedSearchInput
      {...rest}
      value={searchInputValue}
      onTextChange={setSearchInputValue}
    />
  ) : null;
};

SelectSearchInput.displayName = 'SearchInput';

export default SelectSearchInput;
